import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { DetalhamentoFatura } from 'src/app/models/detalhamento-fatura';
import { DetalhamentoFaturaCliente } from 'src/app/models/detalhamento-fatura-cliente';
import { Unidade } from 'src/app/models/Unidade';
import { FaturamentoDetalhado } from 'src/app/models/faturamento-detalhado';
import { FaturamentoDetalhadoCliente } from 'src/app/models/faturamento-detalhado-cliente';
import { DetalhamentoMeuFaturamento } from 'src/app/models/detalhamento-meu-faturamento';

@Injectable({
  providedIn: 'root'
})
export class FaturamentoService {

  constructor(private httpClient: HttpClient) { }

  carregarFaturamento(): Promise<FaturamentoDetalhado> {
    type RetornoWs = {
      data: any[];
    };

    return this.httpClient.get<RetornoWs>(environment.wsUrl + 'faturamento/listarFaturamentos').pipe(map(r => new FaturamentoDetalhado(r.data))).toPromise();
  }

  carregarOutraEmpresa(): Promise<Unidade[]> {
    type RetornoWs = {
      data: any[];
    };

    return this.httpClient.get<RetornoWs>(environment.wsUrl + 'faturamento/outrasEmpresaFaturamento').pipe(map(r => r.data.map(f => new Unidade(f)))).toPromise();
  }

  carregarFaturamentoOutraEmpresa(idUnidade: string): Promise<FaturamentoDetalhado> {
    type RetornoWs = {
      data: any[];
    };

    return this.httpClient.get<RetornoWs>(environment.wsUrl + 'faturamento/listarFaturamentosOutraEmpresa/' + idUnidade).pipe(map(r => new FaturamentoDetalhado(r.data))).toPromise();
  }

  carregarDetalhesFaturamento(idFatura: string, ignore = ['loading']): Promise<FaturamentoDetalhadoCliente> {
    type RetornoWs = {
      data: any[];
    };

    return this.httpClient.get<RetornoWs>(environment.wsUrl + 'faturamento/listarClienteFaturamento/' + idFatura,
      { params: { ignore: ignore } }).pipe(
        map(r => new FaturamentoDetalhadoCliente(r.data))
      ).toPromise();
  }

  enviarNaoFaturar(idFaturamento: string, listaIds: number[]): Promise<DetalhamentoFatura[]> {
    type RetornoWs = {
      data: any[];
    };

    return this.httpClient.post<RetornoWs>(environment.wsUrl + 'faturamento/setStatusNaoFaturar/' + idFaturamento, listaIds).pipe(
      map(r => r.data)
    ).toPromise();
  }

  enviarCancelarNota(idFaturamento: string, listaIds: number[]): Promise<DetalhamentoFatura[]> {
    type RetornoWs = {
      data: any[];
    };

    return this.httpClient.post<RetornoWs>(environment.wsUrl + 'notafiscalservico/cancelarNfeLote/' + idFaturamento, listaIds).pipe(
      map(r => r.data)
    ).toPromise();
  }

  enviarGerarNota(idFaturamento: string, listaIds: number[]): Promise<DetalhamentoFatura[]> {
    type RetornoWs = {
      data: any[];
    };

    return this.httpClient.post<RetornoWs>(environment.wsUrl + 'notafiscalservico/gerarNfeLote/' + idFaturamento, listaIds).pipe(
      map(r => r.data)
    ).toPromise();
  }


  enviarRemssaBoleto(idFaturamento: string, listaIds: number[]): Promise<any[]> {
    type RetornoWs = {
      data: any[];
    };

    return this.httpClient.post<RetornoWs>(environment.wsUrl + 'boleto/geraRemessaLote/' + idFaturamento, listaIds).pipe(
      map(r => r.data)
    ).toPromise();
  }

  enviarGerarBoleto(idFaturamento: string, objetoGerarBoleto: any): Promise<DetalhamentoFatura[]> {
    type RetornoWs = {
      data: any[];
    };

    return this.httpClient.post<RetornoWs>(environment.wsUrl + 'boleto/geraBoletoLote/' + idFaturamento, objetoGerarBoleto).pipe(
      map(r => r.data)
    ).toPromise();
  }

  enviarPdfBoleto( idFaturamento: string, idUnidade: number, form: FormData): Promise<DetalhamentoFatura[]>{
   type RetornoWs = {
      data: any[];
    };
    return this.httpClient.post<RetornoWs>(environment.wsUrl + 'boleto/uploadBoletoPdf/' + idFaturamento + '/' + idUnidade, form).pipe(
      map(r => r.data)
    ).toPromise();
  }

  enviarNotaFiscal( idFaturamento: string, idUnidade: string, form: FormData): Promise<DetalhamentoFatura[]>{
    type RetornoWs = {
      data: any[];
    };
    return this.httpClient.post<RetornoWs>(environment.wsUrl + 'boleto/uploadNfe/' + idFaturamento + '/' + idUnidade, form).pipe(
      map(r => r.data)
    ).toPromise();
  }

  enviarArquivoRetorno(arquivo): Promise<DetalhamentoFatura[]> {
    type RetornoWs = {
      data: any[];
    };

    let form = new FormData();
    //   form.append('tipoConsulta', tipoConsulta);
    form.append('uploadFile', arquivo);

    return this.httpClient.post<RetornoWs>(environment.wsUrl + 'boleto/uploadConsultaLote/', form).pipe(
      map(r => r.data)
    ).toPromise();
  }

  enviarAnexos(idFaturamento: string, listaIds: number[]): Promise<DetalhamentoFatura[]> {
    type RetornoWs = {
      data: any[];
    };

    return this.httpClient.post<RetornoWs>(environment.wsUrl + 'faturamento/enviarAnexoFaturasDetalhadoCliente/' + idFaturamento, listaIds).pipe(
      map(r => r.data)
    ).toPromise();
  }

  carregarDetalhesFaturamentoCliente(idFatura: string, idCliente: string): Promise<DetalhamentoFaturaCliente> {
    type RetornoWs = {
      data: any[];
    };

    return this.httpClient.get<RetornoWs>(environment.wsUrl + 'faturamento/listarFaturasDetalhadoCliente/' + idFatura + '/' + idCliente)
      .pipe(
        map(r => new DetalhamentoFaturaCliente(r.data))
      ).toPromise();
  }

  atualizarTabelaPreco(detalheFaturaCliente): Promise<DetalhamentoFaturaCliente> {
    type RetornoWs = {
      data: any[];
    };

    return this.httpClient.post<RetornoWs>(environment.wsUrl + 'faturamento/atualizarDetalheFaturaCliente/', detalheFaturaCliente)
      .pipe(
        map(r => new DetalhamentoFaturaCliente(r.data))
      ).toPromise();
  }

  atualizarStatusFaturamentoCliente(request: DetalhamentoFatura): Promise<Object>{
    type RetornoWS = {
      data: any[];
    };

    return this.httpClient.post<RetornoWS>(environment.wsUrl + 'faturamento/setStatusFaturamento/' + request.uuidFaturamento + '/' + request.uuidUnidade, request.statusFaturaClienteNovo)
    .pipe(
      map( r => r.data)
    ).toPromise();
  }

  atualizarStatusBoleto(request: DetalhamentoFatura): Promise<Object>{
    type RetornoWS = {
      data: any[];
    };

    return this.httpClient.post<RetornoWS>(environment.wsUrl + 'faturamento/setStatusFaturamento/' + request.idBoleto + '/' + request.idUnidade, request.statusBoletoNovo)
    .pipe(
      map( r => r.data)
    ).toPromise();
  }

  listarMeuFaturamento(idUnidade, ano): Promise<DetalhamentoMeuFaturamento[]> {
    type RetornoWs = {
      data: any[];
    };
    return this.httpClient.get<RetornoWs>(environment.wsUrl + 'faturamento/listarFaturasClientePorAno/' + idUnidade + '/' + ano)
      .pipe(
        map(r => r.data)
      ).toPromise();
  }

  gerarNovoFaturamento(idUnidade: string, novoFaturamento: any): Promise<FaturamentoDetalhado>{
    type RetornoWs = {
      data: any;
    };

    let objFaturamento = {
      periodoFaturamento: novoFaturamento.periodoFaturamento.toString(),
      mesReferente: novoFaturamento.mesReferente.toString(),
      anoReferente: novoFaturamento.anoReferente.toString()
    }

    return this.httpClient.post<RetornoWs>(environment.wsUrl + 'faturamento/gerarNovoFaturamento/' + idUnidade, objFaturamento)
      .pipe(
        map(r => r.data)
      ).toPromise();
  }

  deletarFaturamento(idUnidade: string, idFaturamento: string): Promise<Number>{
    type RetornoWs = {
      data: any;
    };

    return this.httpClient.delete<RetornoWs>(environment.wsUrl + 'faturamento/deletarFaturamento/' + idFaturamento + '/' + idUnidade)
      .pipe(
        map(r => r.data)
      ).toPromise();
  }

}
